import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, ArrowRight, Star, Check, Shield, Award, Lock, CheckCircle2 } from 'lucide-react';
export function Hero() {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  return <section className="relative overflow-hidden bg-gradient-to-br from-cream via-white to-brand-soft/40" data-id="element-275" data-mp="4m8n6ez0uvlz">
      {/* Decorative background shapes (behind content) */}
      <div className="absolute inset-0 pointer-events-none z-0" aria-hidden="true" data-id="element-276" data-mp="1274orr9pfk8a">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-brand/5 blur-3xl" data-id="element-277" data-mp="sbb23f29uacs"></div>
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-accent/5 blur-3xl" data-id="element-278" data-mp="nc89iu3h9wlp"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16 sm:pt-12 sm:pb-20 lg:pt-20 lg:pb-28" data-id="element-279" data-mp="3d1scx40hhvwa">
        <div className="grid lg:grid-cols-12 gap-x-12 gap-y-10 lg:gap-x-16 items-start" data-id="element-280" data-mp="381nwtf3hn36l">
          {/* LEFT — Copy column */}
          <div className="lg:col-span-7" data-id="element-281" data-mp="3j6fwnlhhz5bq">
            <motion.div initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-soft text-brand text-xs font-bold uppercase tracking-[0.2em] mb-7" data-id="element-282" data-mp="3o858h3cjnn0v">
              <Award size={13} strokeWidth={2.5} data-id="element-283" data-mp="35aubxqiar7p4" />
              Mitsubishi Diamond Dealer · Since 1995
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.05
          }} className="text-[34px] sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-ink-900 tracking-tighter leading-[1.08] sm:leading-[1.05]" data-id="element-284" data-mp="2viomanfip2d3">
              Perth's <span className="text-brand" data-id="element-285" data-mp="ic873bxiq0w9">Most Trusted</span> Air
              Conditioning Installer Since 1995
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.15
          }} className="hero-sub mt-5 text-base sm:text-xl text-stone-600 max-w-2xl leading-relaxed" data-id="element-286" data-mp="de6oes4083lb">
              Get a free on-site assessment and fixed price quote from Langler Air. Mitsubishi Electric Diamond Dealer. 5.0★ from 75 Google reviews. Workmanship guarantee on every install.
            </motion.p>

            {/* Trust proof pills */}
            <motion.div initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.25
          }} className="mt-7 grid grid-cols-2 sm:grid-cols-4 gap-2.5" data-id="element-287" data-mp="1x9un6hmanpql">
              {[{
              icon: Check,
              label: 'Fixed price, no surprises'
            }, {
              icon: Shield,
              label: 'On-site assessment'
            }, {
              icon: Phone,
              label: 'Same day callback'
            }, {
              icon: Award,
              label: 'Lifetime workmanship'
            }].map((item, i) => {
              const Icon = item.icon;
              return <div key={i} className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-stone-200 shadow-sm" data-id="element-288" data-mp="4b46ts95i2ix" data-mpi={i}>
                    <span className="w-6 h-6 rounded-full bg-success/10 text-success flex items-center justify-center flex-shrink-0" data-id="element-289" data-mp="e9jx5t0ct7rd">
                      <Icon size={12} strokeWidth={3} data-id="element-290" data-mp="9bigfeqehkj2" />
                    </span>
                    <span className="text-xs sm:text-[13px] font-semibold text-ink-900 leading-tight" data-id="element-291" data-mp="3hpr180mol70o">
                      {item.label}
                    </span>
                  </div>;
            })}
            </motion.div>

            {/* CTAs */}
            <motion.div initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.35
          }} className="mt-8 space-y-3" data-id="element-292" data-mp="3rhwuddoo5uhg">
              <a href="#hero-form" className="group inline-flex items-center justify-center gap-2.5 w-full sm:w-auto h-16 px-8 rounded-xl bg-accent hover:bg-accent-600 text-ink-900 text-lg font-bold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-cta" data-id="element-293" data-mp="19h2r6kuc7o5z">
                Get My Free Quote in 60 Seconds
                <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" strokeWidth={2.5} data-id="element-294" data-mp="1sa6mean7e92p" />
              </a>

              <a href="tel:+61864043888" className="flex items-center gap-2 text-brand text-lg font-bold hover:text-brand-700 transition-colors" data-id="element-295" data-mp="1j7f9s7ild79h">
                <Phone size={18} strokeWidth={2.5} data-id="element-296" data-mp="7s8o4r6uxcng" />
                <span data-id="element-297" data-mp="7vo5k0o06xs1">
                  Or call Langler Air: <span className="tabular-nums" data-id="element-298" data-mp="bvyada027i5b">08 6404 3888</span>
                </span>
              </a>

              <p className="text-xs text-stone-500" data-id="element-299" data-mp="2eg91chfffz6r">
                Free quote. No obligation. No spam. No sales tactics.
              </p>
            </motion.div>

            {/* Social proof line */}
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.45
          }} className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 pt-6 border-t border-stone-200" data-id="element-300" data-mp="24qfzw99010g8">
              <a href="https://www.google.com/search?q=langler+air+perth+reviews" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 group" data-id="element-301" data-mp="1lty0r6rtly9y">
                <div className="flex" data-id="element-302" data-mp="3g4jthebocmkr">
                  {[0, 1, 2, 3, 4].map(i => <Star key={i} size={16} className="fill-amber-400 text-amber-400" data-id="element-303" data-mp="3b5qd9e506hgw" />)}
                </div>
                <span className="font-bold text-ink-900 tabular-nums group-hover:text-brand transition-colors" data-id="element-304" data-mp="3sh5f0i7oazlo">
                  5.0 from 75 verified Google reviews
                </span>
              </a>
              <span className="hidden sm:block w-px h-4 bg-stone-300" data-id="element-305" data-mp="30pzei0o1izvv"></span>
              <span className="text-sm font-medium text-stone-600" data-id="element-306" data-mp="30s2dvbb325d9">
                30+ years installing across Perth
              </span>
            </motion.div>

            {/* Loss-aversion (no fake A$ number) */}
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.55
          }} className="mt-5 text-sm text-stone-600 italic max-w-xl" data-id="element-307" data-mp="3epqx6epi54g7">
              An over sized or under sized system costs more to run and can wear out earlier. Every recommendation starts with an on-site assessment.
            </motion.p>
          </div>

          {/* RIGHT — Quote form (constrained, no crash) */}
          <motion.div id="hero-form" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="lg:col-span-5 relative lg:sticky lg:top-32" data-id="element-308" data-mp="1k2n84d38jtnq">
            <div className="text-xs uppercase tracking-[0.2em] text-brand font-bold mb-3 text-center lg:text-left" data-id="element-309" data-mp="22t50uho2ip93">
              Free Quote
            </div>

            <div className="relative max-w-md mx-auto lg:mx-0 lg:ml-auto bg-white rounded-3xl border border-stone-200 shadow-[0_30px_60px_-15px_rgba(2,110,183,0.25)] overflow-hidden" data-id="element-310" data-mp="deqf868cjiht">
              <div className="px-6 sm:px-7 pt-7 pb-5 border-b border-stone-200" data-id="element-311" data-mp="2k3s4o49o4xkf">
                <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-brand-soft text-brand text-[10px] font-bold uppercase tracking-wider mb-3" data-id="element-312" data-mp="2p1tmklvcyqub">
                  <Award size={11} strokeWidth={2.5} data-id="element-313" data-mp="2fbqv4q3vxky3" />
                  Mitsubishi Diamond Dealer
                </div>
                <h2 className="text-xl sm:text-2xl font-extrabold text-brand tracking-tight" data-id="element-314" data-mp="21bg3hkur42bv">
                  Get Your Fixed Price Quote
                </h2>
                <p className="text-sm text-stone-600 mt-1.5" data-id="element-315" data-mp="268ziimz9wj4v">
                  Same business day callback from our Perth team.
                </p>
                <p className="text-xs text-stone-500 mt-3 flex items-center gap-1.5" data-id="element-316" data-mp="1wc4mcaqh2utr">
                  <Lock size={11} data-id="element-317" data-mp="3mosopc4tkqzl" /> Your info stays private. No spam. No SMS
                  marketing.
                </p>
              </div>

              {submitted ? <div className="px-6 sm:px-7 py-10 text-center" data-id="element-318" data-mp="b3vei4p3vi7i">
                  <div className="w-14 h-14 rounded-full bg-success/15 text-success flex items-center justify-center mx-auto mb-4" data-id="element-319" data-mp="b2amalq9kbct">
                    <CheckCircle2 size={28} data-id="element-320" data-mp="15pe5riy6k4r" />
                  </div>
                  <h3 className="text-xl font-extrabold text-ink-900 mb-2" data-id="element-321" data-mp="17ilza5araec">
                    Got it.
                  </h3>
                  <p className="text-sm text-stone-600 mb-5" data-id="element-322" data-mp="62fw6kebbpst">
                    Our team will call you within 2 business hours.
                  </p>
                  <a href="tel:+61864043888" className="inline-flex items-center gap-2 h-11 px-5 rounded-xl border-2 border-brand text-brand font-bold text-sm hover:bg-brand-soft transition-all" data-id="element-323" data-mp="ys4w0ufadjsu">
                    <Phone size={14} data-id="element-324" data-mp="35jxdi8tpov5t" /> Or call Langler Air: 08 6404 3888
                  </a>
                </div> : <form onSubmit={e => {
              e.preventDefault();
              setSubmitted(true);
            }} className="px-6 sm:px-7 py-6 space-y-4" data-id="element-325" data-mp="39mk4k7ik6c1y">
                  <div className="flex items-center gap-2 mb-1" data-id="element-326" data-mp="2x4zna93bicxb">
                    <div className={`flex-1 h-1 rounded-full transition-colors ${step >= 1 ? 'bg-brand' : 'bg-stone-200'}`} data-id="element-327" data-mp="3bz4f4iq3p94p"></div>
                    <div className={`flex-1 h-1 rounded-full transition-colors ${step >= 2 ? 'bg-brand' : 'bg-stone-200'}`} data-id="element-328" data-mp="2jayvy0ep3s6z"></div>
                    <span className="text-[10px] font-bold text-stone-500 uppercase tracking-wider ml-1 tabular-nums" data-id="element-329" data-mp="2eaknih96mg8f">
                      Step {step}/2
                    </span>
                  </div>

                  {step === 1 ? <>
                      <FormField id="hero-name" label="Your name" placeholder="Sarah" required data-id="element-330" data-mp="20jfwg3jvqw9p" />
                      <FormField id="hero-phone" label="Mobile" placeholder="04XX XXX XXX" type="tel" required data-id="element-331" data-mp="2l7yx6n6jkock" />
                      <FormField id="hero-suburb" label="Suburb (Perth WA)" placeholder="e.g. Karrinyup" required data-id="element-332" data-mp="2z1pwl2qk6ruk" />

                      <button type="button" onClick={() => setStep(2)} className="w-full h-14 rounded-xl bg-accent hover:bg-accent-600 text-ink-900 font-bold transition-all duration-200 flex items-center justify-center gap-2 shadow-cta hover:scale-[1.01] active:scale-[0.99]" data-id="element-333" data-mp="26d2ibr4892qi">
                        Continue (10 seconds)
                        <ArrowRight size={16} strokeWidth={2.5} data-id="element-334" data-mp="3rrygp04nnmbs" />
                      </button>
                    </> : <>
                      <div data-id="element-335" data-mp="1b479rafcmotg">
                        <label htmlFor="hero-service" className="block text-xs font-bold text-ink-900 mb-1.5 uppercase tracking-wider" data-id="element-336" data-mp="1b61jrtp30wir">
                          Service type
                        </label>
                        <select id="hero-service" className="w-full h-12 px-4 rounded-xl bg-white border border-stone-300 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base text-ink-900 appearance-none cursor-pointer" data-id="element-337" data-mp="xdlqhklzgcv1">
                          <option data-id="element-338" data-mp="2hrvrbttrk2qa">I am not sure, help me decide</option>
                          <option data-id="element-339" data-mp="2hq1el2snbgxa">Ducted install</option>
                          <option data-id="element-340" data-mp="2cu3zezt4cgm3">Split install</option>
                          <option data-id="element-341" data-mp="2ktqsp1g47622">Reverse cycle install</option>
                          <option data-id="element-342" data-mp="2ku9y5iokw1z7">Multi head split</option>
                          <option data-id="element-343" data-mp="2ptd3z5cduc88">Commercial install</option>
                          <option data-id="element-344" data-mp="2pqqwf5phrwq0">Old unit removal</option>
                        </select>
                      </div>

                      <div data-id="element-345" data-mp="2funkx98r2lqe">
                        <label htmlFor="hero-message" className="block text-xs font-bold text-ink-900 mb-1.5 uppercase tracking-wider" data-id="element-346" data-mp="2ftuniyvol8kx">
                          Anything else{' '}
                          <span className="text-stone-400 font-normal normal-case tracking-normal" data-id="element-347" data-mp="26vsim88ttvsd">
                            (optional)
                          </span>
                        </label>
                        <textarea id="hero-message" rows={2} placeholder="3 bed single storey, want to cool bedrooms..." className="w-full px-4 py-3 rounded-xl bg-white border border-stone-300 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base text-ink-900 resize-none" data-id="element-348" data-mp="1j4d9nwmjog85"></textarea>
                      </div>

                      <input type="hidden" name="gclid" data-id="element-349" data-mp="1djnr6n3b574p" />
                      <input type="hidden" name="utm_source" data-id="element-350" data-mp="18j01q5uq8ycl" />
                      <input type="hidden" name="utm_medium" data-id="element-351" data-mp="1ngk5xajsuphp" />
                      <input type="hidden" name="utm_campaign" data-id="element-352" data-mp="1nezazjtkp4jb" />
                      <input type="hidden" name="utm_term" data-id="element-353" data-mp="1ii8w2zti8ezh" />
                      <input type="hidden" name="referrer" data-id="element-354" data-mp="1ifmmyvqytrf5" />
                      <input type="hidden" name="page_uri" data-id="element-355" data-mp="1w7kgvzc3vgqq" />

                      <div className="flex gap-2" data-id="element-356" data-mp="1s7ijw3hbfbhs">
                        <button type="button" onClick={() => setStep(1)} className="h-14 px-5 rounded-xl border-2 border-stone-300 hover:border-brand text-ink-900 font-semibold text-sm transition-all" data-id="element-357" data-mp="1s825pva36k13">
                          Back
                        </button>
                        <button type="submit" className="flex-1 h-14 rounded-xl bg-accent hover:bg-accent-600 text-ink-900 font-bold text-base transition-all duration-200 flex items-center justify-center gap-2 shadow-cta hover:scale-[1.01] active:scale-[0.99]" data-id="element-358" data-mp="12x5vbbkjfpkt">
                          Request My Quote
                          <ArrowRight size={16} strokeWidth={2.5} data-id="element-359" data-mp="1mjln2o22a7kr" />
                        </button>
                      </div>
                    </>}

                  <p className="text-xs text-stone-500 leading-snug pt-1 text-center" data-id="element-360" data-mp="1qjvwkap2bg4d">
                    Our team calls within 2 business hours. No spam. No SMS marketing.
                  </p>
                </form>}

              <div className="hidden sm:block px-6 sm:px-7 py-4 bg-stone-50 border-t border-stone-200 rounded-b-3xl" data-id="element-361" data-mp="15z2wjoz01f7">
                <div className="text-xs text-stone-500 mb-2 font-semibold uppercase tracking-wider" data-id="element-362" data-mp="3ptfa0ppenfpj">
                  Authorised installer of:
                </div>
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm font-semibold text-ink-900" data-id="element-363" data-mp="3g2kjh954ltya">
                  <span data-id="element-364" data-mp="3b4is80xjqobq">Mitsubishi Electric</span>
                  <span className="text-stone-300" data-id="element-365" data-mp="3b1o8ycq9r9jw">·</span>
                  <span data-id="element-366" data-mp="cl2h3h84hf59">Daikin</span>
                  <span className="text-stone-300" data-id="element-367" data-mp="ck12x3vt8cjb">·</span>
                  <span data-id="element-368" data-mp="7o28ayjw1yag">Rinnai HRV</span>
                  <span className="text-stone-300" data-id="element-369" data-mp="7kxvjcscxu86">·</span>
                  <span data-id="element-370" data-mp="2mwgd2y1yf1z">iZone</span>
                </div>
                <p className="text-[10px] text-stone-500 mt-2 tabular-nums" data-id="element-371" data-mp="3urqk91jm3s8a">
                  ABN 87 134 927 585 · Mon-Thu 9-4 · Fri 9-2
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
function FormField({
  id,
  label,
  placeholder,
  type = 'text',
  required
}: {
  id: string;
  label: string;
  placeholder: string;
  type?: string;
  required?: boolean;
}) {
  return <div data-id="element-372" data-mp="rbthu2ea9asf">
      <label htmlFor={id} className="block text-xs font-bold text-ink-900 mb-1.5 uppercase tracking-wider" data-id="element-373" data-mp="rclelgjm9eka">
        {label}
        {required && ' *'}
      </label>
      <input id={id} type={type} required={required} placeholder={placeholder} className="w-full h-12 px-4 rounded-xl bg-white border border-stone-300 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base text-ink-900 placeholder:text-stone-400" data-id="element-374" data-mp="ib51v25bx0cw" />
    </div>;
}